<div class=" modal-header d-flex justify-content-center bg-light ">
    <div class="center">
        <h4 class="modal-title strong">Confirm Order</h4>
        <div>Review and confirm your order</div>
    </div>
</div>
<div class="modal-body bg-light">
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
    <div class="center">
        <!-- <div class="small text-secondary  small">Material #</div> -->
        <h5 class="strong mb-2">{{consignForm.get('productName')?.value}}</h5>
        <div><span>Stock Available : </span>{{consignForm.get('stockAvailable')?.value}}</div>
        <div class="bold text-secondary mt-2">{{consignForm.get('location')?.value}}</div>
    </div>
    <div class="d-flex mt-4">
        <div class="col-md-6">
            <div class="text-secondary">Base Price</div>
            <div class="bold">$ {{consignForm.get('basePrice')?.value}}</div>
        </div>
        <div class="col-md-6">
            <div class="text-secondary">Quantity(ST)</div>
            <div class="bold">{{consignForm.get('quantity')?.value}}</div>

        </div>
    </div>
    <hr *ngIf="list?.length>0">
    <div class="container">
        <div class="row" *ngIf="list?.length>0">
            <div class=" col-md-6 mb-3" [ngClass]="{'d-none': item.kopCode=='BASE'}" *ngFor="let item of list; let i=index">
<div class="text-secondary">{{item.kopName}}</div>
<div *ngIf="item.kopPriceSymbol=='$'">
<div class="fw-bold">{{item.kopPriceSymbol}} {{item.kopPriceAmount||0}}</div>
</div>
<div  *ngIf="item.kopPriceSymbol=='%'" class="fw-bold">{{item.kopPriceAmount||0}} {{item.kopPriceSymbol}} </div>
            </div>

        </div>
        </div>

    <hr *ngIf="list?.length>0">
    <div class="d-flex mt-4">
        <div class="col-md-4">
            <div class="text-secondary">Order date*</div>
            <div class="bold">{{this.subconvertedDeliveryDate}}</div>
        </div>
        <!-- <div class="col-md-4">
            <div class="text-secondary">Validity date*</div>
            <div class="bold">{{this.subconvertedDate}}</div>
        </div>
        <div class="col-md-6">
            <div class="text-secondary">Validity time*</div>
            <div class="bold">{{consignForm.get('ValidityTime')?.value}}</div>
        </div> -->
    </div>
    <div class="col-md-5 mt-4">
        <div class="text-secondary">External reference no</div>
        <div class="bold">{{consignForm.get('extRefNo')?.value ? consignForm.get('extRefNo')?.value : '--'}}</div>
    </div>
    <div class="mt-4 col-md-12">
        <p class="mb-2 small strong">Buyer Remarks</p>
        <textarea class="w-100 form-control" [(ngModel)]="Remark" maxlength="5000" placeholder="Enter your Remarks terms here"></textarea>
    </div>
    <div class="mt-4 col-md-12">
        <div>By confirming your bid, you warrant that you are not an Indian resident
            company or using an Indian IP address and will not otherwise trigger the
            Indian Equalisation Levy in accordance with clause 12.2 of the Terms of Use. You agree that you
            must pay BHP an amount equal to the Indian Equalisation Levy if the levy is triggered.</div>
    </div>
</div>
</div>
<div class="modal-footer ">
    <div class="col-md-12 col-sm-12">
        <button class="btn btn-block btn-lg  btn-primary" type="submit" (click)="saveConsignmentOrder()">Confirm order</button>
        <div class="d-flex justify-content-between mt-2">
            <button class="btn btn-light btn-lg button" type="button" (click)="backToplaceOrder()" data-dismiss="modal">Back</button>
            <button class="btn btn-light btn-lg button" type="button" (click)="closeModal('close')"
                data-dismiss="modal">Close</button>
        </div>
    </div>

</div>